import { render, staticRenderFns } from "./UploadMedia.vue?vue&type=template&id=68e8ebbe&scoped=true&lang=pug"
import script from "./UploadMedia.vue?vue&type=script&lang=js"
export * from "./UploadMedia.vue?vue&type=script&lang=js"
import style0 from "./UploadMedia.vue?vue&type=style&index=0&id=68e8ebbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e8ebbe",
  null
  
)

export default component.exports